<script setup>

import { defineProps, ref, watch } from 'vue';
import BaseIcon from "@/components/base/BaseIcon.vue";

const emit = defineEmits(['update:modelValue'])

const value = ref(null)

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null
  },
  errorsMessage: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: 'توضیحات'
  },
  placeholder: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: null
  }
})

watch(
  () => props.modelValue,
  (newValue) => {
    value.value = newValue
  },
  { immediate: true }
)
watch(
  () => value.value,
  (newValue) => {
    emit('update:modelValue', newValue);
  }
)
</script>

<template>
  <div>
    <label>
      <BaseIcon v-if="icon" icon="description" class="tw-align-middle tw-ml-3"/>
      {{ label }}
    </label>
    <textarea cols="3"
              v-model="value"
              :placeholder="placeholder"
              :class="!!errorsMessage ? 'tw-border-red-200' : 'tw-border-static-inputBorder'"
              class="tw-border tw-w-full tw-rounded-[8px] tw-p-1.5 tw-min-h-[70px] placeholder:tw-text-gray-700"></textarea>
    <p v-if="!!errorsMessage" class="tw-text-red-300 tw-mb-0 tw-text-tiny" v-text="errorsMessage"></p>
  </div>
</template>

<style scoped>

</style>
